import locale from "localization";

export const nonCashSummaryColumn = [
  { key: "method", text: locale.paymentMethod },
  { key: "transactionCount", text: locale.noOfTransactions },
  { key: "totalAmount", text: locale.amount },
  {
    key: "discount",
    text: (
      <>
        {locale.discount} /<br /> {locale.premium}
      </>
    ),
  },
  { key: "vatExempt", text: locale.vatExempt },
  { key: "finalAmount", text: locale.finalAmount },
  // { key: "excess", text: locale.excess },
  { key: "actions", text: "" },
];
